import { VOY_FACTORY_ADDRESS } from '../config';
const abi = require('./abi/treasure_hunt_factory.json');

export function getTreasureHuntFactoryContract(web3) {
    const instance = new web3.eth.Contract(
        abi,
        VOY_FACTORY_ADDRESS
    );
    return instance; 
}